import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';

import { DialogService } from '../../services';

@Component({
  selector: 'phoenix-image-gallery',
  templateUrl: './image-gallery.component.html',
  standalone: false,
})
export class ImageGalleryComponent implements OnInit, OnChanges {
  @ViewChild('dialogGalleryTemplate')
  dialogGalleryTemplate!: TemplateRef<unknown>;
  @ViewChild('galleryActionsTemplate')
  galleryActionsTemplate!: TemplateRef<unknown>;

  failedImageUrls: string[] = [];
  @Input() placeholderImg = {
    path: '../../../../../assets/images/placeholder/placeholder.png',
    text: 'placeholder',
  };
  @Input() showThumbnail = true;
  @Input() media!: string[];
  @Input() buttonLabel = 'View media';
  @Input() disabled = false;
  @Output() saveChanges = new EventEmitter<number>();

  dialogService = inject(DialogService);

  currentIndex = 0;
  displayMedia: string[] = [];

  ngOnInit() {
    this.displayMedia = [...this.media];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['media']) {
      this.displayMedia = [...this.media];
    }
  }
  prev() {
    this.currentIndex =
      (this.currentIndex - 1 + this.media.length) % this.media.length;
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.media.length;
  }

  goToSlide(index: number) {
    this.currentIndex = index;
  }

  open() {
    let w;
    w = this.media.length > 0 ? '80vw' : '40vw';
    this.dialogService.info(this.dialogGalleryTemplate, {
      panelClass: ['gallery__custom-dialog-container'],
      width: w,
      data: {
        showActions: true,
        templateActions: this.galleryActionsTemplate,
      },
    });
  }

  removeImage(index: number) {
    this.dialogService
      .confirm('Are you sure you want to remove this image?')
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.media.splice(index, 1);
          this.displayMedia.splice(index, 1);
          if (this.currentIndex >= this.media.length) {
            this.currentIndex = this.media.length - 1;
          }
          this.saveChanges.emit(index);
        }
      });
  }

  onImageLoadError(event: any) {
    event.srcElement.src = this.placeholderImg.path;
  }
}
